export default "__VITE_ASSET__CzTtgJfU__"